module.exports = ".carousel {\n  display: block;\n  height: 89vh; }\n\n.separator {\n  width: 5%;\n  text-align: center;\n  color: lightgray; }\n"